/*
 * @Author: your name
 * @Date: 2020-11-03 15:29:47
 * @LastEditTime: 2021-07-22 14:23:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \znjz-vue\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import {Button, Input, Menu,Icon, MenuItem,Link,Checkbox,CheckboxGroup,Select, RadioButton, Backtop,Upload,Breadcrumb,BreadcrumbItem, Loading,  Cascader,Option,Pagination ,Message,Table, TableColumn,Progress, Image,Form,FormItem, Radio, RadioGroup,  MessageBox,Dialog} from 'element-ui';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import MetaInfo from 'vue-meta-info'  
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/main.css'
import './assets/css/public.css'
import './assets/css/basic.css'
import 'swiper/css/swiper.css'
import Msg from '../config/message';

Vue.use(Button);
Vue.use(Input);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(Link);
Vue.use(Checkbox);
Vue.use(CheckboxGroup,);
Vue.use(RadioButton);
Vue.use(Pagination);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Progress);
Vue.use(Image);
Vue.use(Form);
Vue.use(Icon);
Vue.use(FormItem);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Select);
Vue.use(Option);
Vue.use(Cascader);
Vue.use(Backtop);
Vue.use(Upload);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Dialog);

Vue.use(Loading.directive);
Vue.use(VueAwesomeSwiper)
Vue.use(MetaInfo)
Vue.use(Msg);

Vue.prototype.$loading = Loading.service;
Vue.config.productionTip = false
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$confirm = MessageBox.confirm;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js